import { useContext } from 'react'
import HierarchyItemsContext from '../contexts/hierarchy-items-context'

const useHierarchyItemContext = () => useContext(HierarchyItemsContext)

export default useHierarchyItemContext
